import { api } from "@/redux/api";

import { User } from "@/pages/Public/pages/Login/schema/login";

import { UpdateCourse } from "../../pages/Course/schema/course";

export const courseApi = api.injectEndpoints({
	endpoints: (builder) => ({
		update: builder.mutation<User, UpdateCourse>({
			query: (body) => ({
				url: "course",
				method: "PATCH",
				body,
			}),
			invalidatesTags: ["Me", "Course"],
		}),
		getCourse: builder.query<User, { id: number }>({
			query: ({ id }) => ({
				url: `course/${id}`,
				method: "GET",
			}),
			providesTags: (result, error, arg) => [{ type: "Course", id: arg.id }],
		}),
		downloadCourse: builder.query<Blob, { id: number }>({
			query: ({ id }) => ({
				url: `course/download/${id}`,
				method: "GET",
				responseHandler: async (response: Response) => {
					if (!response.ok) {
						return { error: response.statusText, status: response.status };
					}

					return response.blob();
				},
			}),
		}),
	}),
});

export const { useUpdateMutation, useGetCourseQuery, useLazyDownloadCourseQuery } = courseApi;
export const courseApiReducer = courseApi.reducer;
export const courseApiMiddleware = courseApi.middleware;
